import React from 'react';
import { Block } from '../types';
const WHATSAPP_MENSAJE = 'Hola Carolina, acabo de hacer mi Mapa de Fugas. Mi nombre es...';
const WHATSAPP_NUMERO = '584145681906';
interface ResultsOverlayProps {
  open: boolean;
  blocks: Block[];
  onClose: () => void;
  onReset: () => void;
}
export function ResultsOverlay({
  open,
  blocks,
  onClose,
  onReset
}: ResultsOverlayProps) {
  const crecBloques = blocks.filter(b => b.status === 'crecimiento').length;
  const fugaBloques = blocks.filter(b => b.status === 'fuga').length;
  const crecH = crecBloques * 0.5;
  const fugaH = fugaBloques * 0.5;
  const totalH = crecH + fugaH;
  const pctC = totalH ? Math.round(crecH / totalH * 100) : 0;
  const pctF = totalH ? 100 - pctC : 0;
  const fugas = blocks.filter(b => b.status === 'fuga');
  const cierre = fugaH >= 4 ? <>
        Hoy se te fugaron <b className="text-[var(--dorado)]" data-id="element-36" data-mp="32jua5yadzmpi">{fugaH.toFixed(1)} horas</b>. No es
        que te falten horas en el día: es que una parte de las que ya tienes no está construyendo tu
        negocio. Este es el mismo patrón que vemos en el 100% de los diagnósticos que hacemos: entre
        4 y 6 horas diarias de fuga. La pregunta no es cómo conseguir más tiempo, es cómo diseñar el
        que ya tienes.
      </> : fugaH > 0 ? <>
        Hoy se te fugaron <b className="text-[var(--dorado)]" data-id="element-37" data-mp="1znd4r48j6olj">{fugaH.toFixed(1)} horas</b>. Vas por
        buen camino, y vale la pena mirar con más detalle esos bloques para que no se conviertan en
        un patrón repetido.
      </> : <>
        Hoy no marcaste fugas. Te recomendamos repetir este registro un par de días más para
        confirmar el patrón real de tu semana.
      </>;
  const ctaHref = WHATSAPP_NUMERO ? `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(WHATSAPP_MENSAJE)}` : '#';
  if (!open) return null;
  return <div className="fixed inset-0 bg-[var(--papel)] z-50 overflow-y-auto pb-[60px]" data-id="element-38" data-mp="2sapnt4fhgea3">
      <div className="res-hero bg-[var(--negro)] text-[var(--papel)] px-6 pt-10 pb-[30px] text-left" data-id="element-39" data-mp="s8zn6944trtk">
        <button onClick={onClose} className="bg-transparent border border-[rgba(247,243,233,0.3)] text-[var(--papel)] rounded-[3px] font-mono-jb text-[11px] px-2.5 py-1.5 cursor-pointer mb-[22px]" data-id="element-40" data-mp="o7o2mi047ws8">
          ← Volver al registro
        </button>
        <p className="font-mono-jb text-[11.5px] tracking-[0.14em] uppercase text-[var(--dorado)] mb-2.5" data-id="element-41" data-mp="x5zuencpx0m9">
          Tu diagnóstico
        </p>
        <p className="font-serif-fr italic font-semibold text-[56px] leading-none text-[var(--dorado)] m-0" data-id="element-42" data-mp="16yoyuy9upe83">
          {fugaH.toFixed(1)}h
        </p>
        <p className="text-sm text-[rgba(247,243,233,0.75)] mt-2 max-w-[34ch] leading-[1.5]" data-id="element-43" data-mp="1kvkl5sf45263">
          se te fugaron hoy en actividades que no generaron crecimiento real para tu negocio.
        </p>
        <div className="flex h-3.5 rounded-[2px] overflow-hidden my-[26px] mb-2.5 bg-[rgba(255,255,255,0.08)]" data-id="element-44" data-mp="3mr4i1dwkns4i">
          <div className="bg-[var(--dorado)]" style={{
          width: `${pctC}%`
        }} data-id="element-45" data-mp="1x7whhaxw5c2d" />
          <div className="bg-[var(--rojo)]" style={{
          width: `${pctF}%`
        }} data-id="element-46" data-mp="1x9zh8mouijka" />
        </div>
        <div className="flex justify-between font-mono-jb text-[11px] text-[rgba(247,243,233,0.7)]" data-id="element-47" data-mp="2267qxkk9xkk2">
          <span data-id="element-48" data-mp="1ofcejyakglbq">Crecimiento {pctC}%</span>
          <span data-id="element-49" data-mp="1sgxzm6x985x0">Fuga {pctF}%</span>
        </div>
      </div>

      <div className="res-body px-5 pt-[26px]" data-id="element-50" data-mp="1sfd6mlql8v19">
        <div className="grid grid-cols-2 gap-2.5 mb-[26px]" data-id="element-51" data-mp="1egvk2rcf5okx">
          <div className="bg-white border border-[var(--papel-linea)] rounded-[4px] p-3.5" data-id="element-52" data-mp="1ejrishw3chaf">
            <div className="font-serif-fr font-semibold text-2xl text-[var(--rojo)]" data-id="element-53" data-mp="1jeez3tgxy5dx">
              {(fugaH * 7).toFixed(0)}h
            </div>
            <div className="font-mono-jb text-[10px] uppercase tracking-[0.05em] text-[var(--gris)] mt-1" data-id="element-54" data-mp="19hsglbc37qf2">
              Por semana
            </div>
          </div>
          <div className="bg-white border border-[var(--papel-linea)] rounded-[4px] p-3.5" data-id="element-55" data-mp="2zsx14hp4r3h0">
            <div className="font-serif-fr font-semibold text-2xl text-[var(--rojo)]" data-id="element-56" data-mp="33u8pkjw9pinm">
              {(fugaH * 30).toFixed(0)}h
            </div>
            <div className="font-mono-jb text-[10px] uppercase tracking-[0.05em] text-[var(--gris)] mt-1" data-id="element-57" data-mp="2a6cgjax7x81m">
              Por mes
            </div>
          </div>
        </div>

        <h3 className="font-serif-fr italic font-semibold text-base border-b-2 border-[var(--negro)] pb-2 mb-1" data-id="element-58" data-mp="208oj2d889mfr">
          Dónde se fugaron tus horas
        </h3>
        <div data-id="element-59" data-mp="1w85poeqos8bg">
          {fugas.length === 0 ? <p className="text-[13px] text-[var(--gris)] py-3" data-id="element-60" data-mp="1rfl0xrmn0les">
              No marcaste bloques como fuga hoy.
            </p> : fugas.map(b => <div key={b.id} className="flex justify-between gap-2.5 py-2.5 border-b border-[var(--papel-linea)] text-[13.5px]" data-id="element-61" data-mp="1hhyiwwa1kdql">
                <span className="font-mono-jb text-[11px] text-[var(--gris)] min-w-[44px]" data-id="element-62" data-mp="1cky7e5ufais3">
                  {b.label}
                </span>
                <span className="flex-1 italic" data-id="element-63" data-mp="3k5dhzc5zwanz">
                  {b.activity ? b.activity : '(sin descripción)'}
                </span>
              </div>)}
        </div>

        <div className="my-[30px] mb-5 p-[18px] bg-[var(--negro)] text-[var(--papel)] rounded-[4px] text-sm leading-[1.6]" data-id="element-64" data-mp="3t4s9mexwera2">
          {cierre}
        </div>

        <a href={ctaHref} target="_blank" rel="noopener noreferrer" className="block w-full bg-[var(--dorado)] text-[var(--negro)] text-center no-underline font-bold text-[14.5px] p-[15px] rounded-[4px] mt-2" data-id="element-65" data-mp="1wwfyyq4whni">
          Quiero cerrar estas fugas
        </a>
        <button onClick={onReset} className="block text-center mt-3.5 font-mono-jb text-[11px] text-[var(--gris)] underline bg-none border-none cursor-pointer w-full" data-id="element-66" data-mp="3aczeadvcwtz6">
          Empezar un registro nuevo
        </button>
      </div>
    </div>;
}